import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Form, Button, TextArea } from 'formik-semantic-ui';
import { connect } from 'react-redux';
import { appStateServerRequests } from '../../redux/selectors';
import { ActionType, RootState, ServerRequestStatus } from '../../redux/types';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwRequestTestModalValues {
  testingNotes: string;
  testingSequence?: File;
}

interface PtwRequestTestModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  buttonTitle: string;
  values?: PtwRequestTestModalValues;
  onSubmit: any;
  serverRequest?: ServerRequestStatus;
}

class PPtwRequestTestModal extends Component<PtwRequestTestModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  componentDidUpdate(prevProps: Readonly<PtwRequestTestModalProps>) {
    if (
      this.props.serverRequest &&
      prevProps.serverRequest &&
      !this.props.serverRequest.pending &&
      this.props.serverRequest.pending !== prevProps.serverRequest.pending
    ) {
      this.toggleOpen(false);
    }
  }

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { buttonTitle, values = null, onSubmit, t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button primary onClick={() => this.toggleOpen(true)}>
            {buttonTitle}
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Ricollaudo'} />
        </Modal.Header>
        <Modal.Content>
          <Form initialValues={{ testingNotes: values ? values.testingNotes : '' }} onSubmit={onSubmit}>
            {({ setFieldValue }) => (
              <>
                <TextArea label={t('Testing notes')} name="testingNotes" />

                <input
                  type="file"
                  name="testingSequence"
                  onChange={(e) => {
                    setFieldValue('testingSequence', e.target.files[0]);
                  }}
                />

                <Button onClick={() => this.toggleOpen(false)}>
                  <TranslationComponent stringKey={'Cancel'} />
                </Button>
                <Button.Submit>
                  <TranslationComponent stringKey={'Confirm'} />
                </Button.Submit>
              </>
            )}
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  serverRequest: appStateServerRequests(state, ActionType.PTW_EDIT),
});

export const PtwRequestTestModal = connect(mapStateToProps)(withTranslation()(PPtwRequestTestModal));
